<template>
  <div class="main-container container">
    <div class="main">
      <div class="main-box">
        <!-- <div class="bannerBox">
                    <el-carousel class="banner" :interval="5000" arrow="always">
                        <el-carousel-item v-for="(item, index) in bannerList" :key="index">
                            <img class="bannerImg" v-lazy="item" :key="item.avatar" />
                        </el-carousel-item>
                    </el-carousel>
                </div> -->
        <img class="bannerImg" src="../../assets/img/banner.jpg" />
        <img
          class="banner-bottom-img"
          src="../../assets/img/banner-bottom.jpg"
        />
      </div>
      <div class="content-block">
        <!-- 热门分类 -->
        <!-- <div class="hot_category">
                    <el-tabs v-model="activeName" @tab-click="handleTabClick">
                        <el-tab-pane class="categoryItem" v-for="(item, index) in categoryList" :name="index + ''" :key="index">
                            <span slot="label">
                                <i :class="item.icon"></i>
                                {{ item.name }}
                            </span>
                        </el-tab-pane>
                    </el-tabs>
                </div> -->

        <div class="sayBox box-shadow">
          <router-link :to="'/say'">
            <a
              class="say-item"
              @mouseleave="start"
              @mouseenter="stop"
              v-for="(item, index) in sayList"
              :key="index"
              v-show="index == currentIndex"
            >
              <svg-icon icon-class="say"></svg-icon>
              <span class="say-content" v-html="item.content"> </span>
            </a>
          </router-link>
        </div>
      </div>
      <div class="news-block">
        <!-- <div class="news-content-block">
                    <div class="check-block-title"> 新闻资讯</div>
                    <div class="check-block-en-block">
                        News<i></i>
                    </div>
                    <div class="new-list">
                        <div class="new-left-block"  @click="handleNewDetail(articleList[0].id)">
                            <img  class="new-img" :src="articleList[0].avatar"/>
                            <div class="text-block">
                                <div class="new-title">{{ articleList[0].title }}</div>
                                <div class="new-descri">{{ articleList[0].summary }}</div>
                            </div>
                        </div>
                        <div class="new-rigth-block">
                            <div class="item-block" v-for="(item, index) in  articleList.slice(1, 5) "  @click="handleNewDetail(item.id)">
                                    <div class="new-img">
                                            <div class="imgBox">
                                                <img class="hand-style" v-lazy="item.avatar" :key="item.avatar" />
                                            </div>
                                    </div>
                                    <div class="info">
                                        <div class="new-title">
                                            {{ item.title }}
                                        </div>
                                        <div class="new-descri">{{ item.summary }}</div>
                                    </div>
                            </div>
                            <a class="look-more" @click="handleTags">
                                查看更多>>
                            </a>
                        </div>
                    </div>
                </div> -->

        <div class="news-content-block">
          <div class="title-block">
            <img class="title-img" src="../../assets/img/sub-left.png" />
            <div class="check-block-title title">政策/标准</div>
            <img class="title-img" src="../../assets/img/sub-right.png" />
          </div>
          <div class="check-block-en-block">Policies and standards</div>
          <div class="new-list">
            <div class="new-rigth-block">
              <div
                class="item-block"
                v-for="(item, index) in articleList[0]?.apiArchiveVOS.slice(
                  0,
                  4
                )"
                @click="handleNewDetail(item.id)"
              >
                <!-- <div class="new-img">
                                            <div class="imgBox">
                                                <img class="hand-style" v-lazy="item.avatar" :key="item.avatar" />
                                            </div>
                                    </div> -->
                <div class="info">
                  <div class="new-title">
                    {{ item.title }}
                  </div>
                  <div class="new-descri">{{ item.summary }}</div>
                </div>
              </div>
              <div class="look-more-block">
                <a class="look-more" @click="() => handleTags('34')">
                  查看更多>>
                </a>
              </div>
            </div>
          </div>
        </div>

        <div class="card-search">
          <div class="title-block">
            <img
              class="title-img"
              style="width: 100px"
              src="../../assets/img/sub-left.png"
            />
            <div class="check-block-title title">证书查询</div>
            <img
              class="title-img"
              style="width: 100px"
              src="../../assets/img/sub-right.png"
            />
          </div>
          <div class="check-block-en-block">Certificate Check</div>
          <el-form
            :model="form"
            :rules="rules"
            class="contact-certificate-form"
            ref="form"
          >
            <el-form-item
              label="检验号"
              style="margin-bottom: 38px"
              :label-width="formLabelWidth"
              prop="N"
            >
              <el-input v-model="form.N" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item
              label="校验码"
              :label-width="formLabelWidth"
              prop="QO"
            >
              <el-input v-model="form.QO" autocomplete="off"></el-input>
            </el-form-item>
            <div class="card-certificate-tips">
              提示：新证书数据上传一周后方可查询
            </div>
            <el-form-item label="" :label-width="formLabelWidth">
              <!-- <el-button @click="goback">返回</el-button> -->
              <el-button
                type="primary"
                class="submit-btn"
                @click="submitCertificateForm"
                ><i class="el-icon-search"></i> 搜索</el-button
              >
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class="news-list-kepu">
        <div class="news-content-kepu-block">
          <div class="title-block">
            <img class="title-img" src="../../assets/img/left.png" />
            <div class="check-block-title title">宝石知识</div>
            <img class="title-img" src="../../assets/img/right.png" />
          </div>
          <div class="check-block-en-block">Gemstone knowledge and science</div>
          <div class="new-kepu-list">
            <div class="new-kepu-block">
              <div
                class="item-kepu-block"
                v-for="(item, index) in articleList[1]?.apiArchiveVOS.slice(
                  0,
                  4
                )"
                @click="handleNewDetail(item.id)"
              >
                <img class="kepu-img" v-lazy="item.avatar" :key="item.avatar" />
                <!-- <div class="info">
                                        <div class="new-title">
                                            {{ item.title }}
                                        </div>
                                        <div class="new-descri">{{ item.summary }}</div>
                                    </div> -->
              </div>
            </div>
            <div class="look-more-block">
              <a class="look-more" @click="() => handleTags('35')">
                查看更多>>
              </a>
            </div>
          </div>
        </div>
      </div>

      <div class="news-block">
        <!-- <div class="news-content-block">
                    <div class="check-block-title"> 新闻资讯</div>
                    <div class="check-block-en-block">
                        News<i></i>
                    </div>
                    <div class="new-list">
                        <div class="new-left-block"  @click="handleNewDetail(articleList[0].id)">
                            <img  class="new-img" :src="articleList[0].avatar"/>
                            <div class="text-block">
                                <div class="new-title">{{ articleList[0].title }}</div>
                                <div class="new-descri">{{ articleList[0].summary }}</div>
                            </div>
                        </div>
                        <div class="new-rigth-block">
                            <div class="item-block" v-for="(item, index) in  articleList.slice(1, 5) "  @click="handleNewDetail(item.id)">
                                    <div class="new-img">
                                            <div class="imgBox">
                                                <img class="hand-style" v-lazy="item.avatar" :key="item.avatar" />
                                            </div>
                                    </div>
                                    <div class="info">
                                        <div class="new-title">
                                            {{ item.title }}
                                        </div>
                                        <div class="new-descri">{{ item.summary }}</div>
                                    </div>
                            </div>
                            <a class="look-more" @click="handleTags">
                                查看更多>>
                            </a>
                        </div>
                    </div>
                </div> -->

        <div class="news-content-block-left" style="margin-right: 20px;">
          <div class="title-block">
            <img class="title-img" src="../../assets/img/sub-left.png" />
            <div class="check-block-title title">产业新闻</div>
            <img class="title-img" src="../../assets/img/sub-right.png" />
          </div>
          <div class="check-block-en-block">Industry news</div>
          <div class="new-list">
            <div class="new-rigth-block">
              <div
                class="item-block"
                v-for="(item, index) in articleList[2]?.apiArchiveVOS.slice(
                  0,
                  4
                )"
                @click="handleNewDetail(item.id)"
              >
                <!-- <div class="new-img">
                                            <div class="imgBox">
                                                <img class="hand-style" v-lazy="item.avatar" :key="item.avatar" />
                                            </div>
                                    </div> -->
                <div class="info">
                  <div class="new-title">
                    {{ item.title }}
                  </div>
                  <div class="new-descri">{{ item.summary }}</div>
                </div>
              </div>
              <div class="look-more-block">
                <a class="look-more" @click="() => handleTags('32')">
                  查看更多>>
                </a>
              </div>
            </div>
          </div>
        </div>

        <div class="news-content-block-rigth">
          <div class="title-block">
            <img class="title-img" src="../../assets/img/sub-left.png" />
            <div class="check-block-title title">中心报道</div>
            <img class="title-img" src="../../assets/img/sub-right.png" />
          </div>
          <div class="check-block-en-block">Center news</div>
          <div class="new-list">
            <div class="new-rigth-block">
              <div
                class="item-block"
                v-for="(item, index) in articleList[3]?.apiArchiveVOS.slice(
                  0,
                  4
                )"
                @click="handleNewDetail(item.id)"
              >
                <!-- <div class="new-img">
                                            <div class="imgBox">
                                                <img class="hand-style" v-lazy="item.avatar" :key="item.avatar" />
                                            </div>
                                    </div> -->
                <div class="info">
                  <div class="new-title">
                    {{ item.title }}
                  </div>
                  <div class="new-descri">{{ item.summary }}</div>
                </div>
              </div>
              <div class="look-more-block">
                <a class="look-more" @click="() => handleTags('33')">
                  查看更多>>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="news-content-block">
        <div
          class="title-block"
          style="display: flex; justify-content: center; align-items: center"
        >
          <img class="title-img" src="../../assets/img/left.png" />
          <div class="check-block-title title" style="margin: 0 20px">
            检测相关
          </div>
          <img class="title-img" src="../../assets/img/right.png" />
        </div>
        <div class="check-block-en-block">About testing</div>
      </div>
      <div class="check-range-block">
        <div class="check-block" style="width: 25%">
          <div class="check-block-title" style="text-align: left">检测流程</div>
          <div style="text-align: left">Testing process</div>
          <div class="check-123-list">
            <div>科技为民 检测强国</div>
            <div>用检测科学技术服务全球</div>
          </div>
          <div class="c-123-btn" @click="handleToRangeDetail">查看全部</div>
        </div>
        <div class="line-range"></div>
        <div class="check-block" style="width: 75%">
          <div class="check-block-title" style="text-align: left">检测项目</div>
          <div style="text-align: left">Testing Items</div>
          <div class="check-list">
            <div class="check-item" @click="handleCheck(3)">
              <img class="check-img pic" src="../../assets/img/lushi3.png" />
              <div class="check-text">
                <div class="check-title">绿松石</div>
                <!-- <div class="check-desc">{{ item.desc }}</div> -->
              </div>
            </div>
            <div class="check-item" @click="handleCheck(2)">
              <img class="check-img pic" src="../../assets/img/lushi2.png" />
              <div class="check-text">
                <div class="check-title">贵金属饰品</div>
                <!-- <div class="check-desc">{{ item.desc }}</div> -->
              </div>
            </div>
            <div class="check-item" @click="handleCheck(1)">
              <img class="check-img pic" src="../../assets/img/lushi1.png" />
              <div class="check-text">
                <div class="check-title">珠宝玉石</div>
                <!-- <div class="check-desc">{{ item.desc }}</div> -->
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="about-us-block">
               
                <div class="about-us-content">
                    <img class="about-us-img" src='http://47.120.6.181:8800/turquoise/img/20240513_1715615353226.png' />
                    <div class="about-us-text-block">
                        <div class="about-us-title"> 关于我们</div>
                        <div class="about-us-en-block">
                            <div>
                            ABOUT US 
                            </div>
                        </div>
                        <p class="about-us-text">
                            &nbsp&nbsp&nbsp&nbsp湖北松石检测技术有限公司在各级政府大力支持下，由杨明星教授带领的技术团队于2021年9月在竹山县城关镇国际绿松石城建设成立。本中心致力于推动十堰本土绿松石产业向国际化、专业化和产业价值链高端延伸发展，为驱动十堰绿松石产业快速创新升级、打造世界级绿松石文化中心提供重要技术支撑。
                        </p> 
                        <p class="about-us-text">
                            &nbsp&nbsp&nbsp&nbsp本公司总面积600平方米，配套完善、设施齐全、人才储备充分，已于2022年7月通过湖北省市场监督管理局审查并获得检验检测机构资质认定证书。目前实验室拥有一批深耕珠宝检验检测领域的专业技术人员，其中知名专家教授十余名，储备专业技术人才近二十名。实验室检验检测设备齐全先进...
                        </p> 
                        <div class="look-more-block">
                            <a class="look-more" @click="handleTags">
                                查看更多>>
                            </a>
                        </div>
                    </div>
                </div>
            </div> -->
    </div>
  </div>
</template>

<script>
import { getHomeArticleList, featchHomeData, featchCategory } from "@/api";
import { getSayList } from "@/api/say";
import SiteInfo from "@/components/site/index.vue";
export default {
  components: {
    SiteInfo,
  },
  name: "Home",
  metaInfo: {
    meta: [
      {
        name: "keyWords",
        content: "湖北松石检测技术有限公司,开源博客,www.shiyit.com", //变量或字符串
      },
      {
        name: "description",
        content:
          "一个专注于技术分享的博客平台,大家以共同学习,乐于分享,拥抱开源的价值观进行学习交流",
      },
    ],
  },

  data() {
    return {
      form: {},
      formLabelWidth: "80px",
      rules: {
        N: [{ required: true, message: "请输入检验号", trigger: "blur" }],
        QO: [{ required: true, message: "请输入校验码", trigger: "blur" }],
      },
      centerDialogVisible: false,
      drawer: false,
      videoSrc: "http://api.yujn.cn/api/zzxjj.php",
      emojis: [],
      pageData: {
        pageNo: 1,
        pageSize: 10,
      },
      activeName: "0",
      bannerList: [
        "http://47.120.6.181:8800/turquoise/img/20240523_1716458634573.jpg",
        "http://47.120.6.181:8800/turquoise/img/20240523_1716458554200.jpg",
        "http://47.120.6.181:8800/turquoise/img/20240523_1716458653602.jpg",
      ],
      categoryList: [
        {
          id: null,
          name: "最新",
          icon: "el-icon-news",
          desc: "create_time",
        },
        {
          id: null,
          name: "最热",
          icon: "el-icon-tableware",
          desc: "quantity",
        },
      ],
      articleList: [],
      pages: 0,
      tagList: [],
      newArticleList: [],
      tagStyle: ["", "success", "info", "warning", "danger"],
      sayList: [],
      currentIndex: 0,
      timer: null,
      checkList: [
        {
          title: "珠宝玉石",
          desc: "色相，颜色的特性，可划分为蓝、绿蓝、蓝绿、绿、黄、橙。明度，颜色明亮程度，可划分为亮、明、暗。饱和度，颜色鲜艳程度，可划分为浓、艳、中、浅。",
          path: "../../assets/img/lushi1.png",
        },
        {
          title: "绿松石",
          desc: "在规定的条件下根据密度对绿松石质地进行级别划分，可分为极致密、致密、一般。",
          path: "../../assets/img/lushi2.png",
        },
        {
          title: "贵金属饰品",
          desc: "依据瑕疵(点状物、线状物、网状物、块状物、凹坑、裂纹)的类型、大小、颜色、位置及多少决定的洁净程度对绿松石表面洁净度进行级别划分，可分为极洁净、洁净、一般。",
          path: "../../assets/img/lushi3.png",
        },
      ],
    };
  },
  created() {
    this.getHomeList();
    this.fetchCategoryList();
    this.insertWeather();
    this.handleGetSayList();
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  methods: {
    stop() {
      clearInterval(this.timer);
    },
    start() {
      clearInterval(this.timer);
      if (this.sayList.length > 1) {
        this.timer = setInterval(() => {
          this.currentIndex++;
          if (this.currentIndex > this.sayList.length - 1) {
            this.currentIndex = 0;
          }
        }, 3500);
      }
    },
    handleGetSayList() {
      let pageData = {
        pageNo: 1,
        pageSize: 5,
      };
      getSayList(pageData).then((res) => {
        this.sayList = res.data.records;
        for (var i = 0; i < this.sayList.length; i++) {
          //这里为过滤掉存在视频的说说
          if (this.sayList[i].content.indexOf("<video") > -1) {
            this.sayList.splice(i, 1);
            i = i - 1;
          }
        }
        this.start();
      });
    },
    insertWeather() {
      window.WIDGET = {
        CONFIG: {
          layout: "2",
          width: 230,
          height: 270,
          background: "2",
          dataColor: "000000",
          borderRadius: "5",
          key: "632bf35b75f643fda4f7154697df9f47",
        },
      };
      // const script = document.createElement('script')
      // script.src = 'https://widget.qweather.net/standard/static/js/he-standard-common.js?v=2.0'
      // document.body.appendChild(script)
    },
    openUserInfoDrawer(value) {
      this.$store.state.userInfoDrawer.flag = true;
      this.$store.state.userInfoDrawer.name = value;
    },
    handleClike(id, path) {
      this.$router.push({ path: path, query: { id: id } });
    },
    handleCheck(index) {
      this.$router.push("rangeDetail?index=" + index);
    },
    randomColor() {
      var letters = "0123456789ABCDEF";
      var color = "#";
      do {
        for (var i = 0; i < 6; i++) {
          color += letters[Math.floor(Math.random() * 16)];
        }
      } while (color === "#FFFFFF" || color === "#000000");
      return color;
    },
    isShow(type) {
      return this.$store.state.webSiteInfo.showList.indexOf(type) != -1;
    },
    copy(value) {
      const clipboard = new this.Clipboard(".copyBtn", {
        text: () => value,
      });
      clipboard.on("success", () => {
        clipboard.destroy();
      });
      clipboard.on("error", () => {
        this.$toast.error("复制失败");
        clipboard.destroy();
      });
    },
    nextVideo() {
      this.videoSrc = this.videoSrc + "?temps=" + new Date().getTime();
    },
    handleLogin() {
      this.$store.state.loginFlag = true;
    },
    // 分页
    handlePage() {
      this.pageData.pageNo = 1;
      this.getHomeList();
    },
    getHomeList() {
      this.$bus.$emit("show");
      getHomeArticleList()
        .then((res) => {
          console.log("-1231-res", res.data[0]);
          this.articleList = res.data;
          console.log("---this.articleList[0]", this.articleList);
          // this.pages = res.data
          this.$bus.$emit("close");
        })
        .catch((err) => {
          this.$bus.$emit("close");
        });
    },
    fetchCategoryList() {
      // featchCategory().then(res => {
      //     this.categoryList.push(...res.data)
      // })
    },
    // getHomeData() {
    //     featchHomeData().then(res => {
    //         // this.bannerList = res.extra.articles
    //         this.tagList = res.extra.tagCloud
    //         for (var i = 0; i < this.tagList.length; i++) {
    //             this.tagList[i].font = Math.floor(Math.random() * 10) + 10 + "px"
    //         }
    //         this.newArticleList = res.extra.newArticleList
    //     })
    // },

    handleCategoryClike(item) {
      this.$router.push({
        name: "/category",
        query: { id: item.id, name: item.name },
      });
    },
    submitCertificateForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          const { N, QO } = this.form;
          if (N && QO) {
            console.log("表单验证成功", N, QO, this.form);
            window.open(`https://giccug.zpsx.cn/?N=${N}&QO=${QO}`, "_blank");
          }
        }
      });
    },
    handleAboutUs() {
      this.$router.push("/about");
    },
    handleTags(id) {
      this.$router.push("/tags?categoryId=" + id);
    },
    handleNewDetail(id) {
      this.$router.push("/article/" + id);
    },
    handleToRangeDetail() {
      this.$router.push("/rangeDetail");
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .el-tabs__item {
  color: var(--article-color);
}

/deep/ .is-active {
  color: #409eff;
}

/deep/ .el-tabs__nav-wrap::after {
  background-color: var(--background-color);
}

/deep/ .el-tabs__active-bar {
  background-color: var(--theme-color);
}

/deep/ .el-dialog {
  background-color: rgba(0, 0, 0, 0.5);
  border-radius: 10px;

  .el-dialog__header {
    .el-dialog__title {
      color: #fff;
    }
  }

  .el-dialog__body {
    background-color: rgb(140, 140, 140);
  }

  .conent {
    text-align: center;
  }

  .footer-item {
    color: #fff;
  }
}
.certificate-title {
  margin-bottom: 40rpx;
}
.bannerImg {
  height: 400px;
  width: 100%;
  object-fit: cover;
}
.check-block-title {
  font-family: SimSun, 宋体, "Songti SC";
  text-align: center;
  font-size: 30px;
}
.check-block-en-block {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-bottom: 50px;
  i {
    display: block;
    width: 26px;
    height: 2px;
    background: #c09836;
  }
}
.check-123-list {
  display: flex;
  flex-direction: column;
  color: #666;
  font-size: 20px;
  margin-top: 30px;
  div {
    margin-bottom: 20px;
  }
}
.c-123-btn {
  width: 200px;
  height: 60px;
  line-height: 60px;
  color: #fff;
  text-align: center;
  background-color: #3db4cc;
  margin-top: 40px;
}

.look-more-block {
  text-align: right;
}

.check-range-block {
  display: flex;
  background-image: url("../../assets/img/jianceRange.png");
  background-size: cover;
  height: 400px;
}

.line-range {
  width: 2px;
  height: 80%;
  background-color: #818b95;
  height: 300px;
  margin-top: 50px;
}

.look-more {
  color: #666;
}
.news-block,
.news-list-kepu {
  padding: 60px 5%;
  display: flex;
  .contact-certificate-form {
    margin-left: 20px;
    padding: 60px 40px 60px 40px;
    border: 1px #e1e1e1 solid;
    box-shadow: 4px 4px 4px rgba(0, 0, 0, 0.06);
    .submit-btn {
      background-color: var(--theme-color);
      border-color: var(--theme-color);
    }
    .card-certificate-tips {
      color: #858585;
      margin-top: 18px;
      margin-bottom: 12px;
      padding: 8%;
    }
  }
  .news-content-kepu-block {
    width: 100%;
    .new-kepu-block {
      display: flex;
      justify-content: space-between;
    }
    .info {
      padding: 10px 17px;
    }

    .item-kepu-block {
      background: #f7f7fa;

      .new-img {
        height: 100px;
        overflow: hidden;
      }
      .kepu-img {
        overflow: hidden;
        object-fit: contain;
        width: 300px;
      }
      .new-title {
        font-size: 18px;
      }
      .new-descri {
        margin-top: 7px;
        overflow: hidden;
        text-overflow: ellipsis;
        -webkit-line-clamp: 3;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
      }
    }
  }
  .news-content-block {
    width: 65%;
  }
  .title-block {
    display: flex;
    align-items: center;
    justify-content: center;
    .title {
      margin: 0 20px;
    }
    img {
      height: 25px;
    }
  }
  .news-content-block-left,
  .news-content-block-rigth {
    width: 50%;
  }
  .card-search {
    width: 35%;
  }
  .new-list {
    display: flex;
    justify-content: center;
    .new-left-block {
      width: 480px;
      border: 1px solid #ddd;
      .text-block {
        padding: 15px 20px;
      }
      .new-img {
        width: 480px;
        height: 285px;
        display: block;
      }

      .new-title {
        font-size: 18px;
        color: #000;
      }
      .new-descri {
        color: #666;
        line-height: 24px;
        height: 45px;
        overflow: hidden;
        width: 440px;
        text-overflow: ellipsis;
      }
    }
    .new-rigth-block {
      width: 100%;
      .item-block {
        padding: 20px;
        display: flex;
        border: 1px solid #ddd;
        margin-bottom: 15px;
        .hand-style {
          width: 80px;
          height: 80px;
          border-radius: 10px;
        }
        .info {
          padding-left: 8px;
          .new-title {
            font-size: 18px;
            vertical-align: top;
            text-align: left;
          }
          .new-descri {
            font-size: 14px;
            color: #666;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 3; /* 限制在一个块元素显示的文本的行数 */
            overflow: hidden; /* 隐藏溢出的内容 */
            text-overflow: ellipsis; /* 溢出时显示省略号 */
          }
        }
      }
      .item-block:last-child {
        margin-bottom: 0;
      }
    }
  }
}
.check-block {
  // padding: 20px 20px;
  padding: 60px 5%;
  .check-list {
    display: flex;
    justify-content: space-between;
    width: 100%;
  }
  .check-item {
    padding: 20px;
    width: 33%;
    margin-right: 20px;
    color: #71777c;
    border-radius: 4px;
    display: flex;
    text-align: center;
    flex-direction: column;
    align-items: center;
    // box-shadow:  0px 8px 25px 0px #0000000D;
    &:last-child {
      margin-right: 0;
    }
    .check-text {
      .check-title {
        color: black;
      }
      .check-desc {
        margin-top: 8px;
        width: 100%;
      }
    }
    .check-title {
      text-align: center;
      margin-top: 10px;
    }
    .check-img {
      max-width: 160px;
      height: 160px;
      object-fit: contain;
    }
  }
}

.banner {
  position: relative;
  height: 420px;

  /deep/ .el-carousel__container {
    height: 100%;
  }

  .title {
    position: absolute;
    height: 50px;
    line-height: 50px;
    text-align: center;
    width: 100%;
    bottom: 50px;
    color: #fff;
    background: rgba(0, 0, 0, 0.3);
    z-index: 1;
  }

  .bannerImg {
    width: 100%;
    height: 100%;
  }
}

.main-container {
  width: 100%;

  .about-us-block {
    background-image: url("../../assets/img/partFourBg.jpg");
    background-size: cover;
    padding: 100px 5%;

    .about-us-content {
      margin-top: 20px;
      color: #71777c;
      display: flex;
      .about-us-img {
        width: 400px;
        height: 250px;
        margin-right: 40px;
      }
      .about-us-text-block {
        .about-us-title {
          color: #000;
          font-family: SimSun, 宋体, "Songti SC";
          font-size: 32px;
          text-align: left;
        }
        .about-us-en-block {
          color: #000;
          display: flex;
          flex-direction: column;
          margin-bottom: 20px;
          i {
            display: block;
            width: 26px;
            height: 2px;
            background: #c09836;
          }
        }
        padding: 0 0 30px 20px;
        position: relative;
        .about-us-text {
          margin-top: 8px;
        }
        .look-more {
          position: absolute;
          font-size: 16px;
          bottom: 0;
          right: 0;
        }
      }
    }
  }

  width: 100%;
  @media screen and (max-width: 1118px) {
    padding-left: 10px;
    padding-right: 10px;

    .top-right,
    .rightBox,
    .articleImg {
      display: none;
    }

    .main {
      width: 100%;

      .bannerBox {
        width: 100%;

        .banner {
          height: 200px;
          border-radius: 5px;
        }
      }

      .articleInfo-item {
        width: 95%;
      }
    }
    .check-list {
      flex-wrap: wrap;
    }
    .news-block {
      flex-wrap: wrap;
      .news-content-block,
      .card-search {
        width: 100%;
      }
      .check-img {
        max-width: 250px;
        height: 250px;
        object-fit: contain;
      }
    }
    .card-search {
      padding-top: 50px;
    }
  }

  @media screen and (min-width: 1119px) {
    .main {
      width: 100%;

      .bannerBox {
        width: 100%;

        /deep/ .banner {
          border-radius: 5px;
        }
      }

      .articleImgBox {
        width: 180px;
        height: 110px;
        overflow: hidden;
        border: 1px solid var(--border-line);
        border-radius: 5px;
        margin-left: auto;

        &:hover .articleImg {
          transform: scale(1.1);
        }

        .articleImg {
          width: 100%;
          height: 100%;
          transition: all 0.5s;
        }
      }

      .top-right {
        display: inline-block;
        width: 30%;
        height: 420px;
        margin-left: 20px;

        .soft {
          margin-top: 20px;
          background-color: #007aff;
          overflow: hidden;
          height: 125px;
          position: relative;

          &:hover .overlay {
            opacity: 0;
          }

          .overlay {
            background: rgba(0, 0, 0, 0.3);
            position: absolute;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            opacity: 1;
            width: 100%;
            height: 100%;
            transition: all 0.5s;
          }

          a {
            display: inline-block;
            width: 100%;
            text-decoration: none;
            overflow: hidden;

            img {
              width: 100%;
              height: 100%;
            }

            .soft-title,
            .soft-info {
              display: block;
              padding: 5px;
              text-align: center;
              background: rgba(0, 0, 0, 0.7);
              color: #fff;
            }

            .soft-title {
              position: absolute;
              bottom: 0;
              width: 100%;
            }

            .soft-info {
              position: absolute;
              top: 5px;
              left: 5px;
              font-size: 0.8rem;
            }
          }
        }

        /deep/ .el-image {
          width: 100%;
          height: 47%;

          &:last-child {
            margin-top: 20px;
          }
        }

        /deep/ .wh_content_all {
          background-color: var(--theme-color);
          border-top-left-radius: 10px;
          border-top-right-radius: 10px;
        }
      }

      .rightBox {
        width: 43%;
        margin-left: 20px;

        .box-card {
          font-size: 16px;
          padding: 12px;
          background-color: var(--background-color);
          color: var(--article-color);
          margin-bottom: 15px;

          .card-title {
            padding-left: 40px;

            &::before,
            &::after {
              position: absolute;
              width: 12px;
              height: 12px;
              transform: none;
              background: #fc625d;
              border-radius: 50%;
              top: 4px;
              left: 20px;
              content: "";
            }

            &::after {
              left: 5px;
              background-color: #fdbc40;
            }
          }

          .front,
          .back {
            position: absolute;
            width: 100%;
            transform-style: preserve-3d;
            backface-visibility: hidden;
            transition-duration: 0.5s;
            transition-timing-function: "ease-in";
          }

          .back {
            transform: rotateY(180deg);
            display: flex;
            align-items: center;

            img {
              width: 120px;
              height: 120px;
            }
          }

          &:hover .front,
          &:focus .front {
            transform: rotateY(180deg);
          }

          &:hover .back,
          &:focus .back {
            transform: rotateY(0deg);
          }

          &:hover {
            .clearfix {
              &::before {
                content: "";
                width: 70px;
              }
            }
          }

          .clearfix {
            position: relative;
            margin-bottom: 20px;

            svg {
              width: 22px;
              height: 22px;
              vertical-align: -5px;
              margin-right: 5px;
            }

            &::before {
              content: "";
              width: 25px;
              border: 2px solid #333;
              position: absolute;
              bottom: -10px;
              transition: width 0.5s;
            }
          }
        }

        .recomArticle {
          color: var(--article-color);

          .recomArticleUl {
            display: flex;
            padding: 10px;
            list-style: none;
            flex-wrap: wrap;

            li {
              width: 100%;
              margin-bottom: 20px;

              .imgBox span {
                background-color: #818b95;
              }

              &:first-child {
                .imgBox span {
                  background-color: #f56c6c;
                }
              }

              &:nth-child(2) {
                .imgBox span {
                  background-color: #ffa41b;
                }
              }

              &:nth-child(3) {
                .imgBox span {
                  background-color: #409eff;
                }
              }

              &:last-child {
                margin-bottom: 10px;
              }

              &:hover {
                /deep/ .el-image__inner {
                  transform: scale(1.1);
                }
              }

              .article-item-top1,
              .article-item {
                .recomCover {
                  .imgBox {
                    margin-right: 10px;
                    border-radius: 5px;
                    overflow: hidden;
                    border: 1px solid var(--border-line);
                    position: relative;

                    span {
                      position: absolute;
                      display: inline-block;
                      width: 30px;
                      border-radius: 2px 8px 8px 2px;
                      text-align: right;
                      padding-right: 5px;
                      font-weight: 700;
                      color: #fff;
                      margin-top: 5px;
                      z-index: 50;
                    }

                    img {
                      width: 100%;
                      height: 100%;
                      transition: all 0.5s;
                      margin-right: 10px;
                    }

                    &:hover img {
                      transform: scale(1.1);
                    }
                  }
                }
              }

              .article-item-top1 {
                position: relative;

                .recomCover {
                  //
                  width: 100%;

                  .imgBox {
                    width: 100%;
                    height: 150px;
                  }
                }

                .info {
                  .tuijian-title {
                    text-align: center;
                    width: 100%;
                    position: absolute;
                    bottom: 30px;
                    text-decoration: none;
                    color: #fff;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 2;
                    background: rgba(0, 0, 0, 0.3);
                    padding: 5px 0;

                    &:hover {
                      color: var(--theme-color);
                    }
                  }

                  .time {
                    display: none;
                  }
                }
              }

              .article-item {
                height: 100%;
                display: flex;

                .info {
                  display: flex;
                  flex-direction: column;

                  .tuijian-title {
                    text-decoration: none;
                    color: var(--article-color);
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 2;
                    height: 50%;

                    &:hover {
                      color: var(--theme-color);
                    }
                  }

                  .time {
                    font-size: 0.8rem;
                    color: var(--text-color);
                    margin-top: 10px;
                  }
                }

                .recomCover {
                  .imgBox {
                    width: 120px;
                    height: 75px;
                  }
                }
              }
            }
          }
        }

        .guanzhu {
          .guanzhuList {
            padding: 15px;
            list-style: none;

            .guanzhu-item {
              margin-bottom: 20px;
              height: 40px;
              line-height: 40px;
              font-size: 12px;
              display: flex;
              position: relative;
              border-radius: 3px;
              border: 1px solid #333;

              a {
                text-decoration: none;
                color: var(--text-color);
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                width: 100%;
                flex: 1;

                &:hover {
                  color: var(--theme-color);
                }
              }

              .name {
                position: absolute;
                right: 0;
                width: 60px;
                text-align: center;
                color: #fff;
                transition: width 0.35s;
              }

              &:hover .name {
                width: 80px;
              }

              svg {
                width: 20px;
                height: 20px;
                margin-left: 5px;
                position: relative;
                bottom: -10px;
                margin-right: 10px;
              }
            }

            .github {
              border-color: #606266;

              .name {
                background-color: #606266;
              }
            }

            .gitee {
              border-color: red;

              .name {
                background-color: red;
              }
            }

            .email {
              border-color: #f56c87;

              .name {
                background-color: #f56c87;
              }
            }

            .wechat {
              border-color: #67c23a;

              .name {
                background-color: #67c23a;
              }
            }

            .qq {
              border-color: #409eff;

              .name {
                background-color: #409eff;
              }
            }

            .qqgroup {
              border-color: #ea9518;

              .name {
                background-color: #ea9518;
              }
            }
          }
        }

        .tag_container {
          font-size: 0.9rem;
          background-color: var(--background-color);

          &:hover {
            transition: all 0.3s;
          }

          .clearfix {
            font-size: 16px;

            .more {
              float: right;
              margin-right: 10px;
              font-size: 13px;
              color: var(--text-color);
              text-decoration: none;

              &:hover {
                color: var(--theme-color);
              }
            }
          }

          .tagBox {
            padding-bottom: 10px;
            height: auto;
            margin-top: 10px;
            .tag-item {
              color: #71777c;
              border: 1px solid #71777c;
            }
          }
        }

        .weather {
          /deep/ #he-plugin-standard {
            width: 100% !important;
            background-color: var(--background-color) !important;

            span,
            a {
              color: var(--text-color) !important;
            }
          }
        }
      }
    }
  }

  .main {
    margin-top: 80px;

    .video-container {
      position: relative;
      max-width: 92vw;
      max-height: 100vh;
      border-radius: 40px;
      box-shadow: rgba(0, 51, 203, 0.5) 0px 0px 40px;
      overflow: hidden;
    }

    .main-box {
      width: 100%;
      display: flex;
      flex-direction: column;
    }

    .hot_category {
      margin-top: 30px;

      /deep/ .el-tabs__item:hover span {
        color: #409eff;
      }
    }

    .sayBox {
      background-color: var(--background-color);
      width: 100%;
      margin-bottom: 15px;
      border-radius: 5px;
      overflow: hidden;

      /deep/ a {
        text-decoration: none;
      }

      .say-item {
        display: flex;
        padding: 10px;
        color: var(--article-color);
        animation: fade-in 0.45s linear 1;

        @keyframes fade-in {
          0% {
            transform: translateY(-30px);
          }

          100% {
            transform: translateY(0);
          }
        }

        .say-content {
          display: inline-block;
          width: 100%;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        svg {
          margin-right: 15px;
          width: 22px;
          height: 22px;
          vertical-align: -5px;
          animation: show 1s ease-in-out infinite alternate;
        }

        @keyframes show {
          0% {
            opacity: 1;
          }

          100% {
            opacity: 0.6;
          }
        }
      }
    }

    .content {
      display: flex;

      .articleBox {
        font-size: 1rem;
        width: 100%;

        .articleItem {
          position: relative;
          padding: 10px 5px 10px 15px;
          background-color: var(--background-color);
          margin-bottom: 20px;

          .articleInfo {
            color: var(--article-color);

            .original {
              position: absolute;
              right: 0;
              top: 0;
              width: 0;
              height: 0;
              border-color: transparent #40c9c6;
              /*上下颜色 左右颜色*/
              border-width: 0 40px 40px 0;
              border-style: solid;

              i {
                position: absolute;
                top: 4px;
                right: -37px;
                font-size: 16px;
                color: aquamarine;
              }
            }

            .articleInfo-item {
              display: flex;
              height: 100px;
              justify-content: space-between;

              a {
                color: var(--article-color);
              }

              .top {
                background-image: -webkit-linear-gradient(
                  0deg,
                  #f63c45 0,
                  #f51818 100%
                );
                padding-left: 5px;
                padding-right: 5px;
                display: inline-block;
                border-top-right-radius: 5px;
                border-bottom-left-radius: 5px;
                font-size: 0.9rem;
                margin-right: 5px;
                color: #fff;
              }

              h3 {
                position: relative;
                display: inline-block;
              }

              p {
                margin-top: 10px;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 3;
              }
            }
          }

          .bottumItem {
            align-items: center;
            display: flex;
            margin-top: 20px;
            flex-wrap: wrap;

            .articleUser {
              line-height: 50px;

              span {
                color: var(--theme-color);
                margin-left: 3px;
              }

              .userAvatar {
                vertical-align: middle;
                border: 1px solid var(--border-line);
                transition: transform 0.5s;

                &:hover {
                  transform: rotate(360deg);
                }
              }
            }

            .tag {
              display: inline-block;
              // margin-left: 20px;

              .el-tag {
                margin-right: 8px;
              }
            }

            .articleOhter {
              margin-left: 20px;
              font-size: 0.8rem;
              color: var(--text-color);

              .item {
                margin-right: 10px;

                .name {
                  margin-right: 3px;
                }

                i {
                  margin-right: 3px;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
